import useSWR from 'swr';
import { fetcher, useUser } from 'shared/helpers/axios';

/**
 * Custom hook to fetch and track user's received suggestions
 * @returns {Object} { suggestions, receivedCount, sentCount, totalCount, isLoading, error, mutate }
 */
export const useUserSuggestions = () => {
  const user = useUser();
  
  const { data, error, isLoading, mutate } = useSWR(
    user?.id ? '/interact/suggestions/' : null,
    fetcher,
    {
      // Disabled auto-refresh to prevent rate limiting
      // Use mutate() to manually refresh when needed
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 60000, // 1 minute
      shouldRetryOnError: false,
    }
  );

  const suggestions = data?.results || data || [];
  const userId = user?.id;

  // Count received suggestions (where user is recipient)
  const receivedCount = userId 
    ? suggestions.filter(s => s.recipient === userId && s.status === 'open').length 
    : 0;

  // Count sent suggestions (where user is author)
  const sentCount = userId 
    ? suggestions.filter(s => s.author === userId).length 
    : 0;

  const totalCount = suggestions.length;

  return {
    suggestions,
    receivedCount,
    sentCount,
    totalCount,
    isLoading,
    error,
    mutate,
  };
};
